import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../utils/rel';

class ListTitle extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        /* eslint-disable no-confusing-arrow */
        return (
            <h3 className={styles.list_title}>
                {content.map(
                    (item, index) =>
                        item.children && item.children.length > 0 ? (
                            <React.Fragment key={index}>
                                <a href={item.url} target="_blank" rel={rel}>
                                    {item.title}
                                </a>
                                {item.children.map((item, index) => (
                                    <a key={index} href={item.url} target="_blank" rel={rel}>
                                        {item.title}
                                    </a>
                                ))}
                            </React.Fragment>
                        ) : (
                            <a key={index} href={item.url} target="_blank" rel={rel}>
                                {item.title}
                            </a>
                        ),
                )}
            </h3>
        );
        /* eslint-enable no-confusing-arrow */
    }
}

export default errorBoundary(ListTitle);
